export class ConfigService {
    static ccmClientCookie() {
        return 'CCMClient';
    }

    static cookieCampus() {
        return "CalvaryHomeCampus";
    }

}